import { AppleLogo } from "@phosphor-icons/react";
import { ArrowIcon } from "../lib/icons";

const appStoreUrl = "https://apps.apple.com/pl/app/pavbot-intelligence/id6783130931";
const appInfoUrl = "https://paweltanski.com/pavbotviewer.html";

export function AppPromo() {
  return <section className="app-promo" aria-labelledby="app-promo-title">
    <div className="app-promo-copy">
      <div className="app-promo-product">
        <img src="/assets/pavbot-app-icon.png" alt="Ikona aplikacji Pavbot Intelligence" />
        <div><span>Dedykowana aplikacja iOS</span><strong>Pavbot Intelligence</strong></div>
      </div>
      <h2 id="app-promo-title">Twój briefing także na iPhone i iPadzie.</h2>
      <p>Portal możesz przeglądać również w aplikacji Pavbot Intelligence — z codziennym briefingiem, Pulsem Dnia, zapisanymi materiałami oraz odsłuchem treści i podcastów.</p>
      <div className="app-promo-features" aria-label="Najważniejsze możliwości aplikacji">
        <span>iPhone + iPad</span><span>Audio i TTS</span><span>Zapisane materiały</span>
      </div>
      <div className="app-promo-actions">
        <a className="app-store-button" href={appStoreUrl} target="_blank" rel="noreferrer" aria-label="Pobierz Pavbot Intelligence w App Store">
          <AppleLogo weight="fill" /><span><small>Pobierz w</small>App Store</span><ArrowIcon />
        </a>
        <a className="app-info-link" href={appInfoUrl} target="_blank" rel="noreferrer">Poznaj aplikację na PawelTanski.com <ArrowIcon /></a>
      </div>
    </div>
    <a className="app-promo-qr" href={appStoreUrl} target="_blank" rel="noreferrer" aria-label="Zeskanuj kod QR, aby otworzyć Pavbot Intelligence w App Store">
      <span>Zeskanuj aparatem</span>
      <img src="/pavbot-app-qr.svg" alt="Kod QR do aplikacji Pavbot Intelligence w App Store" />
      <strong>Otwórz App Store</strong>
    </a>
  </section>;
}
